var BaseURL = 'https://kcisapi.kidzonia.co.in/baraka/';

export function getData(type, userData) {
	let headers = new Headers();
	return new Promise((resolve, reject) =>{
		headers.append('auth-key', 'bookmystayrestapi');
		headers.append('authorizations', '25iwFyq/LSO1U');
		headers.append('client-service', 'frontend-client');
		headers.append('content-type', 'application/x-www-form-urlencoded');
		headers.append('user-id','1');

		fetch(BaseURL+type, {
			method: 'POST',
            //headers: headers,
			body: JSON.stringify(userData)
		})
		.then((response) => response.json())
		.then((res) => {
			resolve(res);
		})
		.catch((error) => {
			reject(error);
		});
	});
}

export function getKCISData(type, userData) {
	let BaseURL = 'https://kcisapi.kidzonia.co.in/baraka/';
	let headers = new Headers();
	return new Promise((resolve, reject) =>{
		headers.append('auth-key', 'bookmystayrestapi');
		headers.append('authorizations', '25iwFyq/LSO1U');
		headers.append('client-service', 'frontend-client');
		headers.append('content-type', 'application/x-www-form-urlencoded');
		headers.append('user-id','1');

		fetch(BaseURL+type, {
			method: 'POST',
            //headers: headers,
			body: JSON.stringify(userData)
		})
		.then((response) => response.json())
		.then((res) => {
			resolve(res);
		})
		.catch((error) => {
			reject(error);
		});
	});
}

export function getBarakaData(type, userData) {
	let BaseURL = 'https://kcisapi.kidzonia.co.in/baraka/';
	let headers = new Headers();
	return new Promise((resolve, reject) =>{
		headers.append('auth-key', 'bookmystayrestapi');
		headers.append('authorizations', '25iwFyq/LSO1U');
		headers.append('client-service', 'frontend-client');
		headers.append('content-type', 'application/x-www-form-urlencoded');
		headers.append('user-id','1');

		fetch(BaseURL+type, {
			method: 'POST',
            //headers: headers,
			body: JSON.stringify(userData)
		})
		.then((response) => response.json())
		.then((res) => {
			resolve(res);
		})
		.catch((error) => {
			reject(error);
		});
	});
}

let download = require('./download');
export function downloadData(type, userData) {
	//let BaseURL = 'https://kcisapi.kidzonia.co.in/baraka/';
	let headers = new Headers();
	return new Promise((resolve, reject) =>{
		headers.append('auth-key', 'bookmystayrestapi');
		headers.append('authorizations', '25iwFyq/LSO1U');
		headers.append('client-service', 'frontend-client');
		headers.append('content-type', 'application/octet-stream');
		headers.append('user-id','1');

		fetch(BaseURL+type, {
			method: 'POST',
            //headers: headers,
			body: JSON.stringify(userData)
		}).then(function(response) {
            return response.blob();
          }).then(function(blob) {
		  const url = window.URL.createObjectURL(new Blob([blob]));
		  const link = document.createElement('a');
		  link.href = url;
		  link.setAttribute('download', 'sales_data.xlsx');
		  document.body.appendChild(link);
		  link.click();
		  link.parentNode.removeChild(link);
          });
	});
}

export function downloadExcelReports(type, userData, name) {
	//let BaseURL = 'https://kcisapi.kidzonia.co.in/baraka/';
	let headers = new Headers();
	return new Promise((resolve, reject) =>{
		headers.append('auth-key', 'bookmystayrestapi');
		headers.append('authorizations', '25iwFyq/LSO1U');
		headers.append('client-service', 'frontend-client');
		headers.append('content-type', 'application/octet-stream');
		headers.append('user-id','1');

		fetch(BaseURL+type, {
			method: 'POST',
            //headers: headers,
			body: JSON.stringify(userData)
		}).then(function(response) {
            return response.blob();
          }).then(function(blob) {
		  const url = window.URL.createObjectURL(new Blob([blob]));
		  const link = document.createElement('a');
		  link.href = url;
		  var filename = name+'.xlsx';
		  link.setAttribute('download', filename);
		  document.body.appendChild(link);
		  link.click();
		  link.parentNode.removeChild(link);
          });
	});
}

export function downloadPDFData(type, userData, name) {
	//let BaseURL = 'https://kcisapi.kidzonia.co.in/baraka/';
	let headers = new Headers();
	return new Promise((resolve, reject) =>{
		headers.append('auth-key', 'bookmystayrestapi');
		headers.append('authorizations', '25iwFyq/LSO1U');
		headers.append('client-service', 'frontend-client');
		headers.append('content-type', 'application/octet-stream');
		headers.append('user-id','1');

		fetch(BaseURL+type, {
			method: 'POST',
            //headers: headers,
			body: JSON.stringify(userData)
		}).then(function(response) {
            return response.blob();
          }).then(function(blob) {
		  const url = window.URL.createObjectURL(new Blob([blob]));
		  const link = document.createElement('a');
		  link.href = url;
		  var filename = name+'.pdf';
		  link.setAttribute('download', filename);
		  document.body.appendChild(link);
		  link.click();
		  link.parentNode.removeChild(link);
          });
	});
}

export function qr_children(type, userData) {
	//let BaseURL = 'https://kcisapi.kidzonia.co.in/baraka/';

	let headers = new Headers();
	return new Promise((resolve, reject) =>{
		headers.append('auth-key', 'bookmystayrestapi');
		headers.append('authorizations', '25iwFyq/LSO1U');
		headers.append('client-service', 'frontend-client');
		headers.append('content-type', 'application/x-www-form-urlencoded');
		headers.append('user-id','1');

		fetch(BaseURL+type, {
			method: 'POST',
            //headers: headers,
			body: JSON.stringify(userData)
		}).then(function(response) {
            return response.blob();
          }).then(function(blob) {
		  const url = window.URL.createObjectURL(new Blob([blob]));
		  const link = document.createElement('a');
		  link.href = url;
		  link.setAttribute('download', 'qr_children.zip');
		  document.body.appendChild(link);
		  link.click();
		  link.parentNode.removeChild(link);
          });
	});

}
